/**
 * Katie & Laura — shared Diary remove/delete confirm
 *
 * Same soft-pink <dialog> pattern as Wish list (“Remove from Wishlist?”).
 * Pages call window.klDiaryConfirm(message, cb). Cancel → cb(false); OK → cb(true).
 * Fallback is window.confirm when the dialog is missing.
 */
(function (global) {
  'use strict';

  var pending = null;

  function dialogEl() {
    return typeof document !== 'undefined' ? document.querySelector('[data-kl-diary-confirm]') : null;
  }

  function settle(ok) {
    var fn = pending;
    pending = null;
    var dialog = dialogEl();
    if (dialog && dialog.open && typeof dialog.close === 'function') dialog.close();
    if (fn) fn(!!ok);
  }

  function bind(dialog) {
    if (!dialog || dialog.getAttribute('data-kl-confirm-bound') === '1') return;
    dialog.setAttribute('data-kl-confirm-bound', '1');

    var okBtn = dialog.querySelector('[data-kl-diary-confirm-ok]');
    if (okBtn) {
      okBtn.addEventListener('click', function (event) {
        event.preventDefault();
        settle(true);
      });
    }
    dialog.addEventListener('close', function () {
      var fn = pending;
      pending = null;
      if (fn) fn(false);
    });
  }

  function ask(message, cb, okLabel) {
    if (typeof cb !== 'function') return;
    var dialog = dialogEl();
    var title = dialog && dialog.querySelector('[data-kl-diary-confirm-title]');
    if (title) title.textContent = message || '';
    var okBtn = dialog && dialog.querySelector('[data-kl-diary-confirm-ok]');
    if (okBtn) {
      if (!okBtn.getAttribute('data-default-label')) {
        okBtn.setAttribute('data-default-label', okBtn.textContent || 'Remove');
      }
      okBtn.textContent = okLabel || okBtn.getAttribute('data-default-label');
    }
    bind(dialog);
    if (!dialog || typeof dialog.showModal !== 'function') {
      cb(typeof global.confirm === 'function' ? !!global.confirm(message) : false);
      return;
    }
    if (dialog.open || pending) return;
    pending = cb;
    dialog.showModal();
  }

  function ready(fn) {
    if (typeof document === 'undefined') return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    bind(dialogEl());
  });

  global.klDiaryConfirm = ask;
})(typeof window !== 'undefined' ? window : this);
